'use strict';

module.exports = {
    'en-us': {
        prev: 'Previous',
        next: 'Next',
        goTo: 'Go to',
        page: 'Page',
        go: 'Go',
        pageSize: 'Items per page:'
    },
    'zh-cn': {
        prev: '上一页',
        next: '下一页',
        goTo: '到第',
        page: '页',
        go: '确定',
        pageSize: '每页显示：'
    },
    'zh-tw': {
        prev: '上一頁',
        next: '下一頁',
        goTo: '到第',
        page: '頁',
        go: '確定',
        pageSize: '每頁顯示：'
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-pagination/lib/locale/index.js
// module id = 409
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11